import { render } from "./CertificatePoa.vue?vue&type=template&id=425cb452&scoped=true"
import script from "./CertificatePoa.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificatePoa.vue?vue&type=script&setup=true&lang=js"

import "./CertificatePoa.vue?vue&type=style&index=0&id=425cb452&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425cb452"],['__file',"src/views/poa/CertificatePoa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "425cb452"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('425cb452', __exports__)) {
    api.reload('425cb452', __exports__)
  }
  
  module.hot.accept("./CertificatePoa.vue?vue&type=template&id=425cb452&scoped=true", () => {
    api.rerender('425cb452', render)
  })

}


export default __exports__